import { faHome, faRedo } from '@fortawesome/pro-solid-svg-icons';
import { ActionButton } from 'components';
import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSettingService } from 'services';
import { authentication, isOnline } from 'utils';
import './logout-page.scss';

export const LogoutPage: FC = () => {
  const [isError, setIsError] = useState<boolean>(false);
  const [isSigningOut, setIsSigningOut] = useState<boolean>(true);
  const { deleteTrainerIdKey, deleteTrainingModeKey } = useSettingService();
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      let canLogout = await isOnline()
      if (canLogout) {
        try {
          deleteTrainerIdKey()
          deleteTrainingModeKey()
          await authentication.logout()
        }
        catch {
          canLogout = false
        }
      }
      else {
        canLogout = false
      }

      setIsSigningOut(false)
      setIsError(!canLogout)
    }

    if (isSigningOut) {
      logout()
    }
  }, [isSigningOut]);


  return (
    <div className={'logout-container'}>
      {isError ?
        <div className={'logout-title'}>
          <div>Could not log you out. Ensure you have an internet connection and try again.</div>
          <div className={'logout-error-buttons-container'}>
            <ActionButton
              icon={faRedo}
              buttonText={'Retry'}
              buttonColor={'#adadad'}
              onClick={() => setIsSigningOut(true)}
            />
            <ActionButton
              icon={faHome}
              buttonText={'Home'}
              buttonColor={'#48ACF0'}
              onClick={() => navigate('/load-assignments')}
            />
          </div>
        </div>
        :
        <div className={'logout-title'}>Logging out...</div>
      }
    </div>
  )
}

